module.exports = __webpack_public_path__ + "c7c3799b7819bbc8e827efe794f0a278.woff2";